import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { _T, C, CSS } from '../shared/theme';

const BASE = process.env.REACT_APP_API_URL || '/api';

// ── Plan definitions ───────────────────────────────────────────────────────────
const CATEGORIES = [
  {
    id: 'personal',
    icon: '⚡',
    label: { nl: 'Persoonlijk', en: 'Personal' },
    plans: [
      {
        id: 'starter',
        icon: '🌱',
        name: 'Starter',
        price: { nl: '€1,00 / maand', en: '€1.00 / month' },
        priceNum: 1.00,
        color: '#5B9ED0',
        credits: 8,
        tagline: { nl: 'Minder dan een kop koffie', en: 'Less than a cup of coffee' },
        features: {
          nl: ['Dagelijkse check-ins & slaaplog', 'Cognitieve games (onbeperkt)', 'Basis oefeningen', 'Geluidthema\'s actief', 'Push herinneringen'],
          en: ['Daily check-ins & sleep log', 'Cognitive games (unlimited)', 'Basic exercises', 'Sound themes active', 'Push reminders'],
        },
        credits_info: {
          nl: '8 credits/maand — ideaal voor 2 sessies per week. 1 credit = 1 game of oefening. Perfect als kennismaking met het volledige platform.',
          en: '8 credits/month — ideal for 2 sessions per week. 1 credit = 1 game or exercise. Perfect for getting started on the full platform.',
        },
        unlocks: [
          { icon: '🎮', label: { nl: 'Alle games', en: 'All games' } },
          { icon: '🔊', label: { nl: 'Geluidthema\'s', en: 'Sound themes' } },
          { icon: '🏋️', label: { nl: 'Basis oefeningen', en: 'Basic exercises' } },
          { icon: '📊', label: { nl: 'Basis statistieken', en: 'Basic statistics' } },
        ],
      },
      {
        id: 'athlete',
        icon: '🏃',
        name: 'Athlete',
        price: { nl: '€3,95 / maand', en: '€3.95 / month' },
        priceNum: 3.95,
        color: '#2A9E82',
        credits: 45,
        tagline: { nl: '~€0,09 per sessie', en: '~€0.09 per session' },
        features: {
          nl: ['Alle oefeningen & programma\'s', 'Multiplayer games (2 credits)', 'Geavanceerde statistieken', 'Premium thema\'s', 'Data export'],
          en: ['All exercises & programs', 'Multiplayer games (2 credits)', 'Advanced statistics', 'Premium themes', 'Data export'],
        },
        credits_info: {
          nl: '45 credits/maand — dagelijks gebruik mogelijk. 1 credit = solo game of oefening, 2 credits = multiplayer. Genoeg voor een complete dagelijkse routine.',
          en: '45 credits/month — enough for daily use. 1 credit = solo game or exercise, 2 credits = multiplayer. Enough for a complete daily routine.',
        },
        unlocks: [
          { icon: '🏋️', label: { nl: 'Alle oefeningen', en: 'All exercises' } },
          { icon: '👥', label: { nl: 'Multiplayer', en: 'Multiplayer' } },
          { icon: '📊', label: { nl: 'Geavanceerde stats', en: 'Advanced stats' } },
          { icon: '🎨', label: { nl: 'Premium thema\'s', en: 'Premium themes' } },
          { icon: '📥', label: { nl: 'Data export', en: 'Data export' } },
        ],
      },
      {
        id: 'sensei',
        icon: '🥋',
        name: 'Sensei',
        price: { nl: '€7,95 / maand', en: '€7.95 / month' },
        priceNum: 7.95,
        color: '#D4873A',
        credits: 75,
        badge: { nl: 'Meest gekozen', en: 'Most popular' },
        tagline: { nl: 'Volledige dagelijkse routine', en: 'Complete daily routine' },
        features: {
          nl: ['Sense Lifting Coach (onbeperkt)', 'TTS audio begeleiding', 'Lab programma\'s toegang', 'Adaptieve spelmoeilijkheid', 'Tijdperceptie oefeningen'],
          en: ['Sense Lifting Coach (unlimited)', 'TTS audio guidance', 'Lab program access', 'Adaptive game difficulty', 'Time perception exercises'],
        },
        credits_info: {
          nl: '75 credits/maand — ~2 à 3 sessies per dag. Inclusief AI-coachoudit en geluidsbegeleidde oefeningen. De meeste gebruikers kiezen dit plan voor de coach.',
          en: '75 credits/month — ~2–3 sessions per day. Includes AI coach sessions and audio-guided exercises. Most users choose this plan for the coach.',
        },
        unlocks: [
          { icon: '🤖', label: { nl: 'AI Coach', en: 'AI Coach' } },
          { icon: '🔊', label: { nl: 'TTS begeleiding', en: 'TTS guidance' } },
          { icon: '🧪', label: { nl: 'Lab programma\'s', en: 'Lab programs' } },
          { icon: '⚡', label: { nl: 'Adaptief niveau', en: 'Adaptive level' } },
          { icon: '🕐', label: { nl: 'Tijdperceptie', en: 'Time perception' } },
        ],
      },
      {
        id: 'professional',
        icon: '💎',
        name: 'Professional',
        price: { nl: '€9,95 / maand', en: '€9.95 / month' },
        priceNum: 9.95,
        color: '#C8A84B',
        credits: null,
        tagline: { nl: 'Geen enkele limiet', en: 'Zero limits' },
        features: {
          nl: ['Onbeperkte credits', 'Emotionele stabiliteits-oefeningen', 'Prioriteit support', 'Vroege toegang nieuwe features', 'White-label profiel', 'API toegang'],
          en: ['Unlimited credits', 'Emotional stability exercises', 'Priority support', 'Early access to new features', 'White-label profile', 'API access'],
        },
        credits_info: {
          nl: 'Onbeperkte credits — gebruik de app zonder limieten, elke dag. Voor de serieuze gebruiker die maximale mentale prestaties nastreeft.',
          en: 'Unlimited credits — use the app without limits, every day. For the serious user pursuing peak mental performance.',
        },
        unlocks: [
          { icon: '∞', label: { nl: 'Onbeperkt alles', en: 'Unlimited everything' } },
          { icon: '🧘', label: { nl: 'Emotionele oefeningen', en: 'Emotional exercises' } },
          { icon: '🚀', label: { nl: 'Prioriteit support', en: 'Priority support' } },
          { icon: '⭐', label: { nl: 'Vroege toegang', en: 'Early access' } },
          { icon: '🔌', label: { nl: 'API toegang', en: 'API access' } },
        ],
      },
    ],
  },
  {
    id: 'business',
    icon: '🏢',
    label: { nl: 'Bedrijf', en: 'Business' },
    plans: [
      {
        id: 'companies',
        icon: '🏢',
        name: 'Companies',
        price: { nl: '€49,99 / maand', en: '€49.99 / month' },
        priceNum: 49.99,
        color: '#7B6FD0',
        tagline: { nl: 'Wellness voor je hele team', en: 'Wellness for your entire team' },
        credits_pool: 150,
        features: {
          nl: ['150 credits per maand', '10 medewerkers inbegrepen', '+ €12,50/mnd per extra medewerker', 'Max 250 medewerkers', 'Team wellness dashboard', 'Burnout monitoring & alerts', 'Sector-specifieke inzichten', 'Agenda & exporteer tools', 'Prioriteit support'],
          en: ['150 credits per month', '10 employees included', '+ €12.50/mo per extra employee', 'Max 250 employees', 'Team wellness dashboard', 'Burnout monitoring & alerts', 'Industry-specific insights', 'Agenda & export tools', 'Priority support'],
        },
        credits_info: {
          nl: '150 credits/maand in de gedeelde bedrijfswallet. Één creditpool voor alle medewerkers — zij besteden credits voor oefeningen, games en coach-sessies zonder eigen betaald abonnement. Aanvullen kan altijd via de Wallet.',
          en: '150 credits/month in the shared business wallet. One credit pool for all team members — they spend credits for exercises, games, and coach sessions with no personal subscription needed. Top up anytime from the Wallet.',
        },
        unlocks: [
          { icon: '🏢', label: { nl: 'Bedrijf dashboard', en: 'Business dashboard' } },
          { icon: '👥', label: { nl: 'Medewerkersbeheer', en: 'Employee management' } },
          { icon: '💰', label: { nl: 'Bedrijfswallet', en: 'Business wallet' } },
          { icon: '📊', label: { nl: 'Team analytics', en: 'Team analytics' } },
          { icon: '🔔', label: { nl: 'Burnout alerts', en: 'Burnout alerts' } },
          { icon: '📅', label: { nl: 'Boekingssysteem', en: 'Booking system' } },
        ],
      },
    ],
  },
  {
    id: 'coaching',
    icon: '🎯',
    label: { nl: 'Coaching', en: 'Coaching' },
    plans: [
      {
        id: 'coaches_solo',
        icon: '🎯',
        name: 'Solo',
        price: { nl: '€49 / maand', en: '€49 / month' },
        priceNum: 49,
        color: '#5B9ED0',
        credits_pool: 150,
        tagline: { nl: 'Voor de freelance coach', en: 'For the freelance coach' },
        features: {
          nl: ['Tot 15 klanten', 'Klantbeheer & profielen', 'Sessie planning & tracking', 'Privé notities per klant', 'Coach toolkit', 'Gereedheidsmonitor', 'Basis analytiek'],
          en: ['Up to 15 clients', 'Client management & profiles', 'Session planning & tracking', 'Private notes per client', 'Coach toolkit', 'Readiness monitor', 'Basic analytics'],
        },
        credits_info: {
          nl: '150 sessiecredits/maand inbegrepen. Elke begeleide cliëntsessie kost 1 credit uit jouw coachpool. Klanten hebben geen eigen betaald abonnement nodig — jij betaalt voor hun toegang.',
          en: '150 session credits/month included. Each guided client session costs 1 credit from your coach pool. Clients don\'t need their own paid plan — you cover their access.',
        },
        unlocks: [
          { icon: '🎯', label: { nl: 'Coach dashboard', en: 'Coach dashboard' } },
          { icon: '👤', label: { nl: 'Klantprofielen', en: 'Client profiles' } },
          { icon: '📋', label: { nl: 'Sessietracking', en: 'Session tracking' } },
          { icon: '🔬', label: { nl: 'Gereedheidsmonitor', en: 'Readiness monitor' } },
        ],
      },
      {
        id: 'coaches_club',
        icon: '🏆',
        name: 'Club',
        price: { nl: '€149 / maand', en: '€149 / month' },
        priceNum: 149,
        color: '#4AC87A',
        badge: { nl: 'Populair', en: 'Popular' },
        credits_pool: 500,
        tagline: { nl: 'Voor sportclubs & groepen', en: 'For sports clubs & groups' },
        features: {
          nl: ['Tot 75 klanten', 'Alles in Solo', 'Teams & groepen (5 teams)', 'Wedstrijdplanning', 'Groep wellness overzicht', 'Vragenlijsten (WHO-5, PSS-10)', 'Geavanceerde analytiek'],
          en: ['Up to 75 clients', 'Everything in Solo', 'Teams & groups (5 teams)', 'Match scheduling', 'Group wellness overview', 'Questionnaires (WHO-5, PSS-10)', 'Advanced analytics'],
        },
        credits_info: {
          nl: '500 sessiecredits/maand. Credits gedeeld over alle klanten en groepssessies. Groepssessies kosten 2 credits. Overschot rolt niet over naar de volgende maand.',
          en: '500 session credits/month. Credits shared across all clients and group sessions. Group sessions cost 2 credits. Unused credits do not roll over.',
        },
        unlocks: [
          { icon: '🎯', label: { nl: 'Coach dashboard', en: 'Coach dashboard' } },
          { icon: '👥', label: { nl: 'Teams & groepen', en: 'Teams & groups' } },
          { icon: '📊', label: { nl: 'Groep wellness', en: 'Group wellness' } },
          { icon: '📝', label: { nl: 'Vragenlijsten', en: 'Questionnaires' } },
          { icon: '🏆', label: { nl: 'Wedstrijdplanning', en: 'Match scheduling' } },
        ],
      },
      {
        id: 'coaches_pro',
        icon: '🥇',
        name: 'Pro',
        price: { nl: '€299 / maand', en: '€299 / month' },
        priceNum: 299,
        color: '#C8A84B',
        credits_pool: 1500,
        tagline: { nl: 'Voor grote organisaties', en: 'For large organizations' },
        features: {
          nl: ['Onbeperkt klanten', 'Alles in Club', 'Onbeperkt teams', 'Toernooibeheer', 'Gym & lessen planning', 'CSV export & rapporten', 'Prioriteit support'],
          en: ['Unlimited clients', 'Everything in Club', 'Unlimited teams', 'Tournament management', 'Gym & class scheduling', 'CSV export & reports', 'Priority support'],
        },
        credits_info: {
          nl: '1500 sessiecredits/maand. Prioriteitspool voor grote organisaties. Credits worden proportioneel verdeeld over actieve klanten en teamactiviteiten.',
          en: '1500 session credits/month. Priority pool for large organizations. Credits are distributed proportionally across active clients and team activities.',
        },
        unlocks: [
          { icon: '🎯', label: { nl: 'Coach dashboard', en: 'Coach dashboard' } },
          { icon: '🏆', label: { nl: 'Toernooibeheer', en: 'Tournament mgmt' } },
          { icon: '🏋️', label: { nl: 'Gym & lessen', en: 'Gym & classes' } },
          { icon: '📈', label: { nl: 'CSV rapporten', en: 'CSV reports' } },
        ],
      },
      {
        id: 'coaches_elite',
        icon: '👑',
        name: 'Elite',
        price: { nl: '€499 / maand', en: '€499 / month' },
        priceNum: 499,
        color: '#7B6FD0',
        credits_pool: null,
        tagline: { nl: 'Multi-coach organisatie', en: 'Multi-coach organization' },
        features: {
          nl: ['Onbeperkt klanten', 'Alles in Pro', 'White-label dashboard', 'Multi-coach organisatie', 'API toegang', 'Dedicated support manager', 'Aangepaste integraties'],
          en: ['Unlimited clients', 'Everything in Pro', 'White-label dashboard', 'Multi-coach organization', 'API access', 'Dedicated support manager', 'Custom integrations'],
        },
        credits_info: {
          nl: 'Onbeperkte sessiecredits. Volledig creditbeheer over je gehele multi-coach organisatie. Stel creditlimieten in per coach of team.',
          en: 'Unlimited session credits. Full credit management across your entire multi-coach organization. Set credit limits per coach or team.',
        },
        unlocks: [
          { icon: '🎯', label: { nl: 'Coach dashboard', en: 'Coach dashboard' } },
          { icon: '👑', label: { nl: 'Multi-coach org', en: 'Multi-coach org' } },
          { icon: '🎨', label: { nl: 'White-label', en: 'White-label' } },
          { icon: '🔌', label: { nl: 'API toegang', en: 'API access' } },
          { icon: '🤝', label: { nl: 'Dedicated support', en: 'Dedicated support' } },
        ],
      },
    ],
  },
];

const ALL_PLANS = CATEGORIES.flatMap(cat => cat.plans);
// Personal plans available for selection (freemium is a default state, not selectable)
const PERSONAL_SELECTABLE = CATEGORIES[0].plans;
const BASE_SEATS = 10;
const EXTRA_SEAT_PRICE = 12.50;
const MAX_SEATS = 250;

function calcCompaniesPrice(seats) {
  const extra = Math.max(0, seats - BASE_SEATS);
  return (49.99 + extra * EXTRA_SEAT_PRICE).toFixed(2);
}

// Personal plan order for upgrade/downgrade logic (freemium = floor, not selectable)
const PERSONAL_ORDER = ['freemium', 'starter', 'athlete', 'sensei', 'professional'];
const COACH_ORDER    = ['coaches_solo', 'coaches_club', 'coaches_pro', 'coaches_elite'];

function planRank(id) {
  const pi = PERSONAL_ORDER.indexOf(id);
  if (pi !== -1) return { group: 'personal', rank: pi };
  const ci = COACH_ORDER.indexOf(id);
  if (ci !== -1) return { group: 'coaching', rank: ci };
  if (id === 'companies') return { group: 'business', rank: 0 };
  return null;
}

function isDowngradePlan(fromId, toId) {
  if (fromId === toId) return false;
  if (toId === 'freemium') return true; // can never select freemium as upgrade target
  const from = planRank(fromId);
  const to   = planRank(toId);
  if (!from || !to) return false;
  if (from.group !== to.group) return true; // cross-category = downgrade
  return to.rank < from.rank;
}

function creditDelta(currentId, targetId, nl) {
  const cur = ALL_PLANS.find(p => p.id === currentId);
  const tgt = ALL_PLANS.find(p => p.id === targetId);
  if (!cur || !tgt) return null;
  const curC = cur.credits;
  const tgtC = tgt.credits;
  if (curC === null || tgtC === null) return null; // unlimited
  if (tgtC === null) return nl ? '+∞ credits/mnd' : '+∞ credits/mo';
  const delta = tgtC - (curC || 0);
  if (delta <= 0) return null;
  return `+${delta} ${nl ? 'credits/mnd' : 'credits/mo'}`;
}

// Credit badge for personal plans
function CreditBadge({ plan, nl }) {
  if (plan.credits === null) return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 4, background: 'rgba(200,168,75,0.15)', border: '1px solid rgba(200,168,75,0.3)', borderRadius: 20, padding: '3px 10px', fontSize: 11, fontWeight: 700, color: '#C8A84B' }}>
      ∞ credits
    </div>
  );
  if (plan.credits === 0 || !plan.credits) return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 4, background: `${plan.color}18`, border: `1px solid ${plan.color}44`, borderRadius: 20, padding: '3px 10px', fontSize: 11, fontWeight: 700, color: plan.color }}>
      {nl ? 'Gratis toegang' : 'Free access'}
    </div>
  );
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 4, background: `${plan.color}18`, border: `1px solid ${plan.color}44`, borderRadius: 20, padding: '3px 10px', fontSize: 11, fontWeight: 700, color: plan.color }}>
      ⚡ {plan.credits} {nl ? 'credits/mnd' : 'credits/mo'}
    </div>
  );
}

export default function LicenseSheet({ lang, onClose, license = 'freemium', onLicenseChange, signedUpAt }) {
  const nl = lang === 'nl';
  const daysLeft = signedUpAt ? (() => {
    try {
      // Use date-only (strip time) to avoid timezone/browser inconsistencies with datetime strings
      const dateStr = String(signedUpAt).slice(0, 10); // "YYYY-MM-DD"
      const start = new Date(dateStr);
      const startDay = new Date(start.getFullYear(), start.getMonth(), start.getDate());
      const now = new Date();
      const nowDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const elapsed = Math.floor((nowDay - startDay) / 86400000);
      return Math.max(0, 7 - elapsed);
    } catch { return null; }
  })() : null;
  const trialActive = daysLeft !== null && daysLeft > 0 && license === 'freemium';
  const isFreemium = license === 'freemium';

  const [activeCategory, setActiveCategory] = useState(() => {
    if (license && license.startsWith('coaches')) return 'coaching';
    if (license === 'companies') return 'business';
    return 'personal';
  });
  const [selected, setSelected] = useState(() => {
    if (ALL_PLANS.find(p => p.id === license) && license !== 'freemium') return license;
    if (license && license.startsWith('coaches')) return 'coaches_solo';
    if (license === 'companies') return 'companies';
    return 'sensei';
  });
  const [loading, setLoading] = useState(false);
  const [checkoutError, setCheckoutError] = useState(null);
  const [showDowngradeConfirm, setShowDowngradeConfirm] = useState(false);
  const [teamSize, setTeamSize] = useState(10);

  const handleUpgrade = async (planId) => {
    setLoading(true);
    setCheckoutError(null);
    try {
      const uid = localStorage.getItem('sl_user_id');
      const res = await fetch(`${BASE}/stripe/checkout`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ planId, uid, teamSize: planId === 'companies' ? teamSize : undefined }),
      });
      const data = await res.json();
      if (data.url) {
        window.location.href = data.url;
      } else {
        setCheckoutError(data.error || (nl ? 'Er ging iets mis. Probeer opnieuw.' : 'Something went wrong. Please try again.'));
        setLoading(false);
      }
    } catch {
      setCheckoutError(nl ? 'Verbindingsfout, probeer opnieuw.' : 'Connection error, please try again.');
      setLoading(false);
    }
  };

  const handleDowngrade = async () => {
    setLoading(true);
    setCheckoutError(null);
    try {
      const uid = localStorage.getItem('sl_user_id');
      const res = await fetch(`${BASE}/stripe/portal`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ uid }),
      });
      const data = await res.json();
      if (data.url) {
        window.location.href = data.url;
      } else {
        setCheckoutError(data.error || (nl ? 'Probeer opnieuw.' : 'Please try again.'));
        setLoading(false);
      }
    } catch {
      setCheckoutError(nl ? 'Verbindingsfout, probeer opnieuw.' : 'Connection error, please try again.');
      setLoading(false);
    }
  };

  const plan = ALL_PLANS.find(p => p.id === selected);
  const isActive = plan?.id === license;
  const isDowngrade = !isActive && isDowngradePlan(license, selected);
  const delta = !isActive && !isDowngrade ? creditDelta(license, selected, nl) : null;
  const category = CATEGORIES.find(cat => cat.id === activeCategory);
  const catPlans = category?.plans || [];
  const isPersonal = activeCategory === 'personal';

  return ReactDOM.createPortal(
    <div style={{ position: 'fixed', inset: 0, zIndex: 1000, background: 'rgba(5,8,18,0.92)', backdropFilter: 'blur(10px)', display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={{ width: '100%', maxWidth: 480, background: _T.bg2, borderRadius: '24px 24px 0 0', border: `1px solid ${_T.cardBorderTop}`, padding: '24px 20px 44px', maxHeight: '94vh', overflowY: 'auto', position: 'relative' }}>
        <button onClick={onClose} style={{position:'absolute',top:14,right:14,background:'transparent',border:'none',color:C.silver,fontSize:20,cursor:'pointer',padding:4,lineHeight:1,zIndex:2}}>✕</button>
        <style>{CSS}</style>
        <div style={{ width: 36, height: 4, borderRadius: 2, background: _T.cardBorderBot, margin: '0 auto 20px' }} />

        {/* Trial / freemium banner */}
        {trialActive && (
          <div style={{ background: 'rgba(42,158,130,0.12)', border: '1px solid rgba(42,158,130,0.35)', borderRadius: 12, padding: '12px 14px', marginBottom: 16, display: 'flex', alignItems: 'center', gap: 10 }}>
            <span style={{ fontSize: 20 }}>⏳</span>
            <div>
              <div style={{ color: '#2A9E82', fontSize: 13, fontWeight: 700 }}>
                {nl ? `Nog ${daysLeft} gratis dag${daysLeft !== 1 ? 'en' : ''}` : `${daysLeft} free day${daysLeft !== 1 ? 's' : ''} left`}
              </div>
              <div style={{ color: C.silver, fontSize: 11 }}>
                {nl ? 'Kies een plan om je voortgang te bewaren en geluid te ontgrendelen.' : 'Choose a plan to keep your progress and unlock sound.'}
              </div>
            </div>
          </div>
        )}

        {!trialActive && isFreemium && (
          <div style={{ background: 'rgba(91,158,208,0.10)', border: '1px solid rgba(91,158,208,0.3)', borderRadius: 12, padding: '12px 14px', marginBottom: 16, display: 'flex', alignItems: 'center', gap: 10 }}>
            <span style={{ fontSize: 20 }}>🔒</span>
            <div>
              <div style={{ color: '#5B9ED0', fontSize: 13, fontWeight: 700 }}>
                {nl ? 'Je gebruikt de gratis versie' : 'You\'re on the free plan'}
              </div>
              <div style={{ color: C.silver, fontSize: 11 }}>
                {nl ? 'Geluid, AI-coach en premium functies zijn vergrendeld.' : 'Sound, AI coach, and premium features are locked.'}
              </div>
            </div>
          </div>
        )}

        <div style={{ fontSize: 9, color: _T.accent, letterSpacing: 3, fontWeight: 600, marginBottom: 4 }}>LICENTIE</div>
        <div style={{ fontFamily: 'Georgia,serif', fontSize: 20, color: C.white, marginBottom: 4 }}>
          {nl ? 'Kies jouw plan' : 'Choose your plan'}
        </div>
        <div style={{ color: C.silver, fontSize: 12, marginBottom: 20 }}>
          {nl ? 'Elke upgrade ontgrendelt meer functies, meer credits en een rijkere ervaring.' : 'Every upgrade unlocks more features, more credits, and a richer experience.'}
        </div>

        {/* Category selector */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 6, marginBottom: 16 }}>
          {CATEGORIES.map(cat => {
            const hasCurrent = cat.plans.some(p => p.id === license);
            const active = activeCategory === cat.id;
            return (
              <button key={cat.id} onClick={() => {
                setActiveCategory(cat.id);
                setSelected(cat.plans[cat.id === 'personal' ? 2 : 0].id); // default to sensei for personal
                setShowDowngradeConfirm(false);
                setCheckoutError(null);
              }}
                style={{ background: active ? `${_T.accent}18` : _T.bg4, border: `1.5px solid ${active ? _T.accent : _T.cardBorderBot}`, borderRadius: 14, padding: '10px 4px', cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, position: 'relative' }}>
                <span style={{ fontSize: 20 }}>{cat.icon}</span>
                <span style={{ fontSize: 9, color: active ? _T.accent : C.silver, fontWeight: active ? 700 : 400, textAlign: 'center' }}>{nl ? cat.label.nl : cat.label.en}</span>
                {hasCurrent && !isFreemium && <div style={{ position: 'absolute', top: -5, right: -5, background: C.teal, borderRadius: 8, width: 11, height: 11 }} />}
              </button>
            );
          })}
        </div>

        {/* Personal: plan picker (no freemium) */}
        {isPersonal && (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 6, marginBottom: 14 }}>
            {PERSONAL_SELECTABLE.map(p => {
              const active = selected === p.id;
              const isCurrent = p.id === license;
              return (
                <button key={p.id} onClick={() => { setSelected(p.id); setShowDowngradeConfirm(false); setCheckoutError(null); }}
                  style={{ padding: '10px 4px', borderRadius: 14, border: `1.5px solid ${active ? p.color : (isCurrent ? p.color + '66' : _T.cardBorderBot)}`, background: active ? `${p.color}18` : (isCurrent ? `${p.color}08` : _T.bg4), cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, position: 'relative' }}>
                  <span style={{ fontSize: 18 }}>{p.icon}</span>
                  <span style={{ fontSize: 10, color: active ? p.color : (isCurrent ? p.color : C.silver), fontWeight: active || isCurrent ? 700 : 400 }}>{p.name}</span>
                  <span style={{ fontSize: 9, color: active ? p.color : (isCurrent ? p.color + 'aa' : '#4a5568') }}>
                    {p.credits === null ? '∞' : p.credits === 0 ? nl ? 'Gratis' : 'Free' : `${p.credits}cr`}
                  </span>
                  {p.badge && (
                    <span style={{ position: 'absolute', top: -7, right: -4, background: p.color, borderRadius: 6, fontSize: 7, fontWeight: 700, color: '#000', padding: '1px 4px' }}>
                      {nl ? p.badge.nl : p.badge.en}
                    </span>
                  )}
                  {isCurrent && (
                    <div style={{ position: 'absolute', bottom: -5, left: '50%', transform: 'translateX(-50%)', background: C.teal, borderRadius: 6, fontSize: 6, fontWeight: 700, color: '#000', padding: '1px 5px', whiteSpace: 'nowrap' }}>
                      {nl ? 'ACTIEF' : 'ACTIVE'}
                    </div>
                  )}
                </button>
              );
            })}
          </div>
        )}

        {/* Coaching: plan picker */}
        {!isPersonal && catPlans.length > 1 && (
          <div style={{ display: 'flex', gap: 6, marginBottom: 16, overflowX: 'auto', paddingBottom: 4 }}>
            {catPlans.map(p => {
              const active = selected === p.id;
              return (
                <button key={p.id} onClick={() => { setSelected(p.id); setShowDowngradeConfirm(false); setCheckoutError(null); }}
                  style={{ flexShrink: 0, padding: '7px 14px', borderRadius: 20, border: `1.5px solid ${active ? p.color : _T.cardBorderBot}`, background: active ? `${p.color}20` : _T.bg4, color: active ? p.color : C.silver, fontSize: 12, fontWeight: active ? 700 : 400, cursor: 'pointer', position: 'relative' }}>
                  {p.icon} {p.name}
                  {p.badge && (
                    <span style={{ position: 'absolute', top: -7, right: -6, background: p.color, borderRadius: 8, fontSize: 8, fontWeight: 700, color: '#000', padding: '2px 5px' }}>
                      {nl ? p.badge.nl : p.badge.en}
                    </span>
                  )}
                  {p.id === license && <span style={{ position: 'absolute', top: -7, left: -6, background: C.teal, borderRadius: 8, width: 11, height: 11, display: 'block' }} />}
                </button>
              );
            })}
          </div>
        )}

        {/* Selected plan card */}
        {plan && (() => {
          const ac = plan.color;
          return (
            <div style={{ background: `${ac}0d`, border: `1.5px solid ${ac}44`, borderRadius: 20, padding: '20px 18px', marginBottom: 16 }}>

              {/* Plan header */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10 }}>
                <div style={{ width: 48, height: 48, borderRadius: 14, background: `${ac}20`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24 }}>{plan.icon}</div>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                    <div style={{ color: C.white, fontSize: 17, fontWeight: 700 }}>{plan.name}</div>
                    {isPersonal && <CreditBadge plan={plan} nl={nl} />}
                    {delta && (
                      <div style={{ display: 'inline-flex', alignItems: 'center', gap: 3, background: 'rgba(74,200,122,0.15)', border: '1px solid rgba(74,200,122,0.3)', borderRadius: 20, padding: '2px 8px', fontSize: 10, fontWeight: 700, color: '#4AC87A' }}>
                        {delta}
                      </div>
                    )}
                  </div>
                  <div style={{ color: ac, fontSize: 14, fontWeight: 600, marginTop: 2 }}>
                    {plan.id === 'companies' && !isActive
                      ? `€${calcCompaniesPrice(teamSize).replace('.', ',')} / ${nl ? 'maand' : 'month'}`
                      : (nl ? plan.price.nl : plan.price.en)}
                  </div>
                  {plan.tagline && (
                    <div style={{ color: C.silver, fontSize: 11, marginTop: 2 }}>
                      {nl ? plan.tagline.nl : plan.tagline.en}
                    </div>
                  )}
                </div>
                {isActive && (
                  <div style={{ background: `${C.teal}20`, border: `1px solid ${C.teal}44`, color: C.teal, fontSize: 10, fontWeight: 700, borderRadius: 20, padding: '3px 10px', flexShrink: 0 }}>
                    {nl ? 'ACTIEF' : 'ACTIVE'}
                  </div>
                )}
              </div>

              {/* 🔓 What unlocks in the app */}
              {plan.unlocks && plan.unlocks.length > 0 && (
                <div style={{ background: `${ac}08`, border: `1px solid ${ac}22`, borderRadius: 12, padding: '10px 12px', marginBottom: 10 }}>
                  <div style={{ fontSize: 9, color: ac, fontWeight: 700, letterSpacing: 2, marginBottom: 8 }}>
                    🔓 {nl ? 'ACTIVEERT IN DE APP' : 'ACTIVATES IN APP'}
                  </div>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5 }}>
                    {plan.unlocks.map((u, i) => (
                      <div key={i} style={{ display: 'inline-flex', alignItems: 'center', gap: 5, background: `${ac}15`, border: `1px solid ${ac}33`, borderRadius: 20, padding: '4px 10px' }}>
                        <span style={{ fontSize: 12 }}>{u.icon}</span>
                        <span style={{ fontSize: 10, color: C.white, fontWeight: 500 }}>{nl ? u.label.nl : u.label.en}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* ⚡ Credit system */}
              {plan.credits_info && (
                <div style={{ background: 'rgba(200,168,75,0.06)', border: '1px solid rgba(200,168,75,0.2)', borderRadius: 12, padding: '10px 12px', marginBottom: 10 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 5 }}>
                    <div style={{ fontSize: 9, color: '#C8A84B', fontWeight: 700, letterSpacing: 2 }}>
                      ⚡ {nl ? 'CREDITSYSTEEM' : 'CREDIT SYSTEM'}
                    </div>
                    {plan.credits_pool != null && (
                      <span style={{ background: 'rgba(200,168,75,0.2)', borderRadius: 8, padding: '1px 8px', fontSize: 10, fontWeight: 800, color: '#C8A84B' }}>
                        {plan.credits_pool_label ? (nl ? plan.credits_pool_label.nl : plan.credits_pool_label.en) : `${plan.credits_pool} / ${nl ? 'mnd' : 'mo'}`}
                      </span>
                    )}
                    {plan.credits_pool === null && (
                      <span style={{ background: 'rgba(200,168,75,0.2)', borderRadius: 8, padding: '1px 8px', fontSize: 10, fontWeight: 800, color: '#C8A84B' }}>∞</span>
                    )}
                    {plan.credits != null && plan.credits > 0 && (
                      <span style={{ background: 'rgba(200,168,75,0.2)', borderRadius: 8, padding: '1px 8px', fontSize: 10, fontWeight: 800, color: '#C8A84B' }}>
                        {plan.credits} / {nl ? 'mnd' : 'mo'}
                      </span>
                    )}
                    {plan.credits === null && !plan.credits_pool && (
                      <span style={{ background: 'rgba(200,168,75,0.2)', borderRadius: 8, padding: '1px 8px', fontSize: 10, fontWeight: 800, color: '#C8A84B' }}>∞</span>
                    )}
                  </div>
                  <div style={{ color: C.silver2, fontSize: 11, lineHeight: 1.6 }}>
                    {nl ? plan.credits_info.nl : plan.credits_info.en}
                  </div>
                </div>
              )}

              {/* Features list */}
              <div style={{ borderTop: `1px solid ${ac}18`, paddingTop: 10, marginBottom: 12 }}>
                <div style={{ fontSize: 9, color: C.silver, fontWeight: 600, letterSpacing: 2, marginBottom: 7 }}>
                  {nl ? 'WAT IS INBEGREPEN' : 'WHAT\'S INCLUDED'}
                </div>
                {(nl ? plan.features.nl : plan.features.en).map((f, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginBottom: 6 }}>
                    <div style={{ width: 15, height: 15, borderRadius: '50%', background: `${ac}20`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: 1 }}>
                      <span style={{ color: ac, fontSize: 8, fontWeight: 700 }}>✓</span>
                    </div>
                    <span style={{ color: C.silver2, fontSize: 12, lineHeight: 1.4 }}>{f}</span>
                  </div>
                ))}
              </div>

              {/* Companies team size calculator */}
              {plan.id === 'companies' && !isActive && (
                <div style={{ background: `${ac}10`, border: `1px solid ${ac}30`, borderRadius: 14, padding: '14px 16px', marginBottom: 14 }}>
                  <div style={{ fontSize: 9, color: ac, fontWeight: 700, letterSpacing: 2, marginBottom: 10 }}>{nl ? 'BEREKEN JOUW PRIJS' : 'CALCULATE YOUR PRICE'}</div>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
                    <span style={{ color: C.silver, fontSize: 12 }}>{nl ? 'Aantal medewerkers' : 'Number of employees'}</span>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <button onClick={() => setTeamSize(s => Math.max(1, s - 1))}
                        style={{ width: 28, height: 28, borderRadius: 8, background: _T.bg4, border: `1px solid ${_T.cardBorderBot}`, color: C.white, fontSize: 16, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>−</button>
                      <span style={{ color: C.white, fontWeight: 700, fontSize: 15, minWidth: 28, textAlign: 'center' }}>{teamSize}</span>
                      <button onClick={() => setTeamSize(s => Math.min(MAX_SEATS, s + 1))}
                        style={{ width: 28, height: 28, borderRadius: 8, background: _T.bg4, border: `1px solid ${_T.cardBorderBot}`, color: C.white, fontSize: 16, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>+</button>
                    </div>
                  </div>
                  <input type="range" min={1} max={MAX_SEATS} value={teamSize} onChange={e => setTeamSize(Number(e.target.value))}
                    style={{ width: '100%', accentColor: ac, marginBottom: 10 }} />
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                    <span style={{ color: C.silver, fontSize: 11 }}>
                      {nl ? '10 inbegrepen' : '10 included'}{teamSize > BASE_SEATS ? ` + ${teamSize - BASE_SEATS} × €12,50` : ''}
                    </span>
                    <span style={{ color: C.white, fontSize: 20, fontWeight: 800 }}>€{calcCompaniesPrice(teamSize).replace('.', ',')} <span style={{ fontSize: 11, color: C.silver, fontWeight: 400 }}>/mo</span></span>
                  </div>
                </div>
              )}

              {/* Action buttons */}
              {isActive ? (
                <div style={{ background: `${C.teal}10`, border: `1px solid ${C.teal}30`, borderRadius: 12, padding: '10px 14px', textAlign: 'center' }}>
                  <div style={{ color: C.teal, fontSize: 13, fontWeight: 600 }}>✓ {nl ? 'Dit is jouw huidige plan' : 'This is your current plan'}</div>
                  {!isFreemium && (
                    <div style={{ color: C.silver, fontSize: 11, marginTop: 4 }}>
                      {nl ? 'Beheer abonnement via de Stripe klantportal.' : 'Manage your subscription via the Stripe customer portal.'}
                    </div>
                  )}
                </div>
              ) : isDowngrade ? (
                showDowngradeConfirm ? (
                  <div style={{ background: '#3a1a1a', border: '1px solid #C0505066', borderRadius: 14, padding: '16px' }}>
                    <div style={{ color: '#C05050', fontSize: 13, fontWeight: 700, marginBottom: 8 }}>⚠️ {nl ? 'Weet je het zeker?' : 'Are you sure?'}</div>
                    <div style={{ color: C.silver, fontSize: 12, lineHeight: 1.6, marginBottom: 14 }}>
                      {nl
                        ? 'Als je downgradet verlies je functies en credits van je huidige pakket. Dit kan niet ongedaan worden gemaakt.'
                        : 'Downgrading removes features and credits from your current package. This cannot be undone.'}
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                      <button onClick={() => setShowDowngradeConfirm(false)}
                        style={{ background: 'transparent', border: `1px solid ${_T.cardBorderBot}`, borderRadius: 12, color: C.silver, fontSize: 13, fontWeight: 600, padding: '11px 0', cursor: 'pointer' }}>
                        {nl ? 'Annuleren' : 'Cancel'}
                      </button>
                      <button onClick={handleDowngrade} disabled={loading}
                        style={{ background: loading ? '#C0505066' : '#C05050', border: 'none', borderRadius: 12, color: '#fff', fontSize: 13, fontWeight: 700, padding: '11px 0', cursor: loading ? 'default' : 'pointer' }}>
                        {loading ? '...' : (nl ? 'Downgraden' : 'Downgrade')}
                      </button>
                    </div>
                    {checkoutError && <div style={{ color: '#ff6b6b', fontSize: 11, textAlign: 'center', marginTop: 8 }}>{checkoutError}</div>}
                  </div>
                ) : (
                  <button onClick={() => setShowDowngradeConfirm(true)}
                    style={{ width: '100%', background: 'transparent', border: `1.5px solid #C05050`, borderRadius: 14, color: '#C05050', fontSize: 13, fontWeight: 700, padding: '13px 0', cursor: 'pointer' }}>
                    {nl ? 'Downgraden via klantportal →' : 'Downgrade via customer portal →'}
                  </button>
                )
              ) : (
                <>
                  <button onClick={() => handleUpgrade(plan.id)} disabled={loading}
                    style={{ width: '100%', background: loading ? `${ac}66` : `linear-gradient(135deg,${ac},${ac}cc)`, border: 'none', borderRadius: 14, color: '#fff', fontSize: 14, fontWeight: 700, padding: '14px 0', cursor: loading ? 'default' : 'pointer', letterSpacing: 0.3 }}>
                    {loading
                      ? (nl ? 'Doorsturen...' : 'Redirecting...')
                      : isFreemium
                        ? (nl ? `Start met ${plan.name} — ${nl ? plan.price.nl : plan.price.en} →` : `Start ${plan.name} — ${plan.price.en} →`)
                        : (nl ? `Upgraden naar ${plan.name} →` : `Upgrade to ${plan.name} →`)}
                  </button>
                  {delta && (
                    <div style={{ textAlign: 'center', color: '#4AC87A', fontSize: 11, fontWeight: 600, marginTop: 8 }}>
                      {nl ? `Je krijgt ${delta} extra` : `You gain ${delta} extra`}
                    </div>
                  )}
                  {checkoutError && <div style={{ color: '#ff6b6b', fontSize: 11, textAlign: 'center', marginTop: 8 }}>{checkoutError}</div>}
                </>
              )}
            </div>
          );
        })()}

        {/* Freemium: show what they're missing */}
        {isFreemium && activeCategory === 'personal' && (
          <div style={{ background: 'rgba(212,135,58,0.07)', border: '1px solid rgba(212,135,58,0.2)', borderRadius: 14, padding: '12px 14px', marginBottom: 12 }}>
            <div style={{ fontSize: 9, color: '#D4873A', fontWeight: 700, letterSpacing: 2, marginBottom: 8 }}>
              🔒 {nl ? 'VERGRENDELD OP GRATIS PLAN' : 'LOCKED ON FREE PLAN'}
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5 }}>
              {[
                { icon: '🔊', nl: 'Geluidthema\'s', en: 'Sound themes' },
                { icon: '🤖', nl: 'AI Coach', en: 'AI Coach' },
                { icon: '🧪', nl: 'Lab programma\'s', en: 'Lab programs' },
                { icon: '👥', nl: 'Multiplayer', en: 'Multiplayer' },
                { icon: '📊', nl: 'Geavanceerde stats', en: 'Advanced stats' },
                { icon: '⚡', nl: 'Onbeperkte sessies', en: 'Unlimited sessions' },
              ].map((item, i) => (
                <div key={i} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, background: 'rgba(212,135,58,0.10)', border: '1px solid rgba(212,135,58,0.2)', borderRadius: 20, padding: '3px 9px', opacity: 0.8 }}>
                  <span style={{ fontSize: 11 }}>{item.icon}</span>
                  <span style={{ fontSize: 10, color: '#D4873A', fontWeight: 500 }}>{nl ? item.nl : item.en}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Cross-sell coaching */}
        {activeCategory !== 'coaching' && !license.startsWith('coaches') && (
          <div style={{ background: '#7B6FD015', border: '1px solid #7B6FD033', borderRadius: 14, padding: 12, marginBottom: 12, display: 'flex', alignItems: 'center', gap: 10 }}>
            <span style={{ fontSize: 20 }}>🎯</span>
            <div style={{ flex: 1 }}>
              <div style={{ color: C.white, fontSize: 12, fontWeight: 600 }}>{nl ? 'Ook coach?' : 'Are you a coach?'}</div>
              <div style={{ color: C.silver2, fontSize: 11 }}>{nl ? 'Coach-licentie geeft je een volledig klantbeheer-dashboard.' : 'A coach license gives you a full client management dashboard.'}</div>
            </div>
            <button onClick={() => { setActiveCategory('coaching'); setSelected('coaches_solo'); }}
              style={{ background: '#7B6FD020', border: '1px solid #7B6FD044', borderRadius: 8, color: '#7B6FD0', fontSize: 11, fontWeight: 700, padding: '5px 10px', cursor: 'pointer', whiteSpace: 'nowrap' }}>
              {nl ? 'Bekijk' : 'View'}
            </button>
          </div>
        )}

        <div style={{ color: C.silver, fontSize: 11, textAlign: 'center', lineHeight: 1.6 }}>
          {nl ? 'Maandelijks gefactureerd · Op elk moment opzegbaar · Veilig via Stripe' : 'Billed monthly · Cancel anytime · Secure checkout via Stripe'}
        </div>
      </div>
    </div>,
    document.body
  );
}
